<template>
  <div class="chart-widget">
    <v-row class="select-row">
      <v-col cols="12" class="select-col">
        <v-select
          v-model="type"
          :items="types"
          label="Tipo"
          prepend-inner-icon="mdi-format-list-bulleted-type"
          filled
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="chart-row">
      <SimplePie
        v-if="chart"
        :value="chart"
        id="historic-customers"
      />
    </v-row>
  </div>
</template>

<script>
import SimplePie from '@/components/charts/apex/SimplePie'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { SimplePie },
  mixins: [ appdata, utils ],
  props: {
    customData: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    types: [
      {
        text: 'Cidades',
        value: 'cities'
      }
    ],
    type: 'cities'
  }),
  computed: {
    data () {
      return (this.customData ? (this.socketInfo.custom_data ? this.socketInfo.custom_data.customers : []) : (this.get_data ? this.get_data.customers : []))
    },
    chart () {
      switch (this.type) {
        case 'cities':
          return this.citiesChart()
      }
      return []
    }
  },
  methods: {
    /* citiesChart () {
      let chart = []
      const data = this.data.map((el) => el.addresses)
      const flatten = data.reduce((add, val) => add.concat(val), [])
      console.log('flatten cities', flatten)
      let group = flatten.reduce((r, a) => {
        r[a.city] = { title: a.city, value: (r[a.city] ? (parseInt((r[a.city].value) || 0) + 1) : 1) }
        return r
      }, [])
      console.log('group cities', group)
      let sorted = group.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      console.log('sorted cities', sorted)
      sorted.forEach(function (obj) {
        console.log('push to', obj)
        if (obj != null) chart.push(obj)
      })
      console.log('fixed cities', chart)
      chart = chart.slice(0, 10)
      console.log('citiesChart', chart)
      return chart
    }, */
    citiesChart () {
      let chart = []
      const addressesList = this.data.map((el) => el.addresses)
      console.log('addressesList', addressesList)
      addressesList.forEach((array) => {
        console.log('array', array)
        if (array.length > 0) {
          array.forEach((obj, iobj) => {
            console.log('iobj', iobj)
            console.log('obj', obj)
            var index = chart.findIndex(a => a.title === `${obj.city} / ${obj.state}`)
            var index_ = array.findIndex((a, ia) => (a.title === `${obj.city} / ${obj.state}` && ia !== iobj))
            console.log('index', index)
            console.log('index_', index_)
            if (index > -1) {
              chart[index].value = (index_ < 0 ? (parseInt((chart[index].value) || 0) + 1) : parseInt(chart[index].value))
            } else {
              chart.push({ title: `${obj.city} / ${obj.state}`, value: 1 })
            }
          })
        }
      })
      console.log('group cities', chart)
      /* let sorted = group.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      console.log('sorted cities', sorted)
      console.log('fixed cities', chart)
      chart = chart.slice(0, 10)
      console.log('citiesChart', chart) */
      return chart
    }
  }
}
</script>
